const EMAIL_REGEX =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const emojiRegex = /\p{Extended_Pictographic}/u;

export const isValidEmail = (email: string) =>
  !!email.match(EMAIL_REGEX) && !email.match(emojiRegex);
